import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit'>;

type Response = {
  count: number;
};

export const getAssetsCount = async (
  scope: RequestScope,
  { limit = 1000 }: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`assets/count?limit=${limit}`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
